import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'platform-branch-not-found-dialog',
    standalone: true,
    imports: [ButtonModule],
    template: `
        <div class="flex flex-column p-3">
            <div class="flex justify-content-end">
                <p-button label="OK" (onClick)="onButtonClick()" styleClass="w-full height-44"></p-button>
            </div>
        </div>
    `,
})
export class BranchNotFoundDialogComponent {
    private dialogRef = inject(DynamicDialogRef);

    onButtonClick() {
        this.dialogRef.close(true);
    }
}
